import { gql } from "@apollo/client";
export const CREATE_DCDD_USER = gql`
  mutation CreateDcddUser($signup_input: DcddSignupInput) {
    createDcddUser(signup_input: $signup_input) {
     data {
            user {
                category
                created_at
                email
                id
                login_id
                mobile_no
                password
                status
                student_id
                updated_at
                user_identifier
            }
            user_profile {
                cid
                created_at
                dob
                dzongkhag_id
                eccd_id
                gender
                grade_id
                id
                name
                profile_picture
                student_id
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

export const UPDATE_DCDD_USER = gql`
  mutation UpdateDcddUser($user_id: UUID, $signup_input: DcddSignupInput) {
    updateDcddUser(user_id: $user_id, signup_input: $signup_input) {
      data {
            user {
                category
                created_at
                email
                id
                login_id
                mobile_no
                password
                status
                student_id
                updated_at
                user_identifier
            }
            user_profile {
                cid
                created_at
                dob
                dzongkhag_id
                eccd_id
                gender
                grade_id
                id
                name
                profile_picture
                student_id
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const UPDATE_DCDD_USER_PASSOWRD = gql`
mutation UpdateDcddUserPassword($user_id:UUID, $ResetPasswordInput:ResetPasswordInput!) {
    updateDcddUserPassword(user_id: $user_id, ResetPasswordInput: $ResetPasswordInput) {
        data {
            user {
                category
                created_at
                email
                id
                login_id
                mobile_no
                password
                status
                student_id
                updated_at
                user_identifier
            }
            user_profile {
                cid
                created_at
                dob
                dzongkhag_id
                eccd_id
                gender
                grade_id
                id
                name
                profile_picture
                student_id
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;

export const UPDATE_DCDD_USER_STATUS = gql`
  mutation UpdateDcddUserStatus($status: String!, $userID: UUID!) {
    UpdateDcddUserStatus(status: $status, userID: $userID) {
     data {
            user {
                category
                created_at
                email
                id
                login_id
                mobile_no
                password
                status
                student_id
                updated_at
                user_identifier
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;

export const BULK_REGISTRATION = gql`
  mutation BulkRegistration($csv_path: String) {
    bulkRegistration(csv_path: $csv_path) {
      data {
        message
      }
      error {
        code
        field
        message
      }
    }
  }
`;
